/*
 * AuthO boilerplate
 * Responsible for showing the footer
 */

import React from 'react';
import { getTranslation } from '../utils/translations';

const Footer = () => {
    const brandName = process.env.REACT_APP_BRAND;
    const capitalizedBrand = brandName[0].toUpperCase() + brandName.slice(1);
    const footerText = getTranslation('footerText', { brand: capitalizedBrand });

    return (
        <footer className="mx-1 px-3 pb-4 d-flex flex-column flex-lg-row align-items-center justify-content-between footer">
            <img src="/shared/secure.png" className="d-none d-lg-block" alt="security" />
            <p className="login-bottom__text mx-auto mb-2 mb-lg-0">
              {footerText}
            </p>

            <div className="d-flex align-items-center">
                <img
                    src="/shared/secure-sm.png"
                    className="d-lg-none mr-2"
                    alt="security"
                />
                <img
                    src="/shared/mastercard.png"
                    className="mr-2"
                    width="23"
                    height="18"
                    alt="mastercard"
                />
                <img
                    src="/shared/maestro.png"
                    className="mr-2"
                    width="24"
                    height="18"
                    alt="maestro"
                />
                <img
                    src="/shared/logo-visa.png"
                    className="mr-2"
                    width="36"
                    height="36"
                    alt="visa"
                />
                <img src="/shared/18plus.png" width="16" height="16" alt="18plus" />
            </div>
        </footer>
    );
};

export default Footer;
